import { render } from "./NewPresupuestoPage.vue?vue&type=template&id=5665a5d6"
import script from "./NewPresupuestoPage.vue?vue&type=script&lang=js"
export * from "./NewPresupuestoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__